import LogsPage from './role-logs-page';

export default function RoleLogsPage() {
  return <LogsPage />;
}
